module.exports = __webpack_public_path__ + "media/images/black_history_month/african-kitchen-9e3f2bb3f7a078615eed07a7d72e0068.png";